import { Button } from '@mantine/core';
import { Icon, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { SettingView } from 'app/modules/wallforming/components/setting-container/types/settingView';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SettingNavigator = ({
    isCopilotFloating = false,
    onSettingViewSelect
}: {
    isCopilotFloating?: boolean;
    onSettingViewSelect?: (settingView: SettingView) => void;
}) => {
    const { t } = useTranslation();
    const { selectedSettingView, setSelectedSettingView } = usePlacementStore(
        useShallow((state) => ({
            selectedSettingView: state.selectedSettingView,
            setSelectedSettingView: state.setSelectedSettingView
        }))
    );

    return (
        <>
            {Object.values(SettingView).map((label, index) => (
                <Button
                    key={`${label}-${index}`}
                    aria-label={label === SettingView.COPILOT ? t('copilotOpen') : label}
                    aria-pressed={selectedSettingView === label}
                    className={`
                            min-w-28 flex justify-center h-10
                            ${
                                label === SettingView.COPILOT
                                    ? `bg-background-information-ultra-light-focus! text-text-accent! font-semibold data-[selected=true]:bg-background-information-ultra-light-focus! ${
                                          isCopilotFloating
                                              ? 'hover:bg-background-information-ultra-light-focus!'
                                              : 'hover:bg-border-accent-light!'
                                      }`
                                    : `data-[selected=true]:bg-background-action-focus data-[selected=false]:bg-background-default ${
                                          isCopilotFloating
                                              ? 'data-[selected=true]:hover:bg-background-action-focus! data-[selected=false]:hover:bg-background-default!'
                                              : 'hover:bg-background-action-focus!'
                                      }`
                            }
                        `}
                    data-copilot-dock-target={label === SettingView.COPILOT ? '' : undefined}
                    data-selected={selectedSettingView === label}
                    leftSection={
                        label === SettingView.COPILOT ? (
                            <Icon
                                aria-hidden="true"
                                className="mr-2" 
                                icon="auto_awesome"
                                size="lg"
                            />
                        ) : undefined
                    }
                    name={label}
                    style={{ fontSize: '0.8rem' }}
                    variant={variants.button.secondary}
                    data-input-ui
                    onClick={() => {
                        if (onSettingViewSelect) {
                            onSettingViewSelect(label);
                        } else {
                            setSelectedSettingView(label);
                        }
                    }}
                >
                    {label}
                </Button>
            ))}
        </>
    );
};
